module.exports = __webpack_public_path__ + "img/mt.f5c28c0a.svg";